import axios, { AxiosInstance } from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { AuthCookie } from '../components/_shared/types';
import cookies from 'src/libs/cookies';

export const API_HOSTNAME =
  (process.env.REACT_APP_BASE_PATH ??
    globalThis.window.__ENV__?.REACT_APP_BASE_PATH) ||
  '/';
const API_URL = API_HOSTNAME.concat('api/v4/admin');
const STORAGE_URL =
  (process.env.REACT_APP_STORAGE_URL ??
    globalThis.window.__ENV__?.REACT_APP_STORAGE_URL) ||
  API_HOSTNAME;

export const downloadLink = (
  url: string,
  directory: string,
  type: 'image' | 'video' = 'image'
) => {
  if (!url) return '';

  // абсолютный URL
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return url;

  const basePath = STORAGE_URL;

  const path = `${type}s/${directory.toLowerCase()}/${url}`;
  const base = basePath.endsWith('/') ? basePath : `${basePath}/`;

  // абсолютный storage
  if (/^[a-z][a-z0-9+.-]*:/i.test(base)) return new URL(path, base).href;

  // относительный storage
  return `${base}${path}`.replace(/\/{2,}/g, '/');
};

const refreshAuthLogic = (API: AxiosInstance) => (failedRequest: any) => {
  const auth: AuthCookie | undefined = cookies.get('auth');

  if (!auth?.refreshToken && !auth?.userName) {
    if (failedRequest.response?.status === 401) {
      cookies.remove('auth', { path: '/' });
      // window.location.href = '/';
    }
    return Promise.reject(failedRequest);
  }

  return API.post('/auth/refresh', {
    userName: auth.userName,
    token: auth.refreshToken,
  })
    .then(({ data }) => {
      console.log('refresh');
      const now = new Date();
      const oneMonth = 30 * 24 * 60 * 60 * 1000;
      now.setTime(now.getTime() + oneMonth);
      cookies.set(
        'auth',
        {
          ...auth,
          accessToken: data.token,
          refreshToken: data.refreshToken,
        },
        { path: '/', expires: now, sameSite: 'lax' }
      );
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        cookies.remove('auth', { path: '/' });
        // window.location.href = '/';
      }
      Promise.reject(failedRequest);
    });
};

// TODO APIv4
// Должно быть удалено после перехода на v4

// переменная для хранения cityId
let currentCityId: number | null = null;

const setCityIdForApi = (id: number | null) => {
  currentCityId = id;
};

const APIv4 = axios.create({
  baseURL: API_URL,
  responseType: 'json',
  headers: {
    post: {
      'Access-Control-Allow-Origin': '*',
    },
  },
});

APIv4.interceptors.request.use(
  (config) => {
    const auth: AuthCookie | undefined = cookies.get('auth');
    if (auth) config.headers['Authorization'] = `Bearer ${auth.accessToken}`;

    if (currentCityId) config.headers['X-Tt-City-Id'] = currentCityId;

    // Заменяем, так как API_URL в .env не подходит
    if (config.url?.includes('audit') || config.url?.includes('back-office')) {
      config.baseURL = config.baseURL?.replace('admin', '');
    }

    if (config.params) {
      config.params = Object.fromEntries(
        Object.entries(config.params).filter(([_, value]) => {
          if (value === undefined || value === null) return false;
          if (typeof value === 'string' && value.trim() === '') return false;
          return true;
        })
      );
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

APIv4.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      return Promise.reject(error);
    }
  }
);

createAuthRefreshInterceptor(APIv4, refreshAuthLogic(APIv4), {
  pauseInstanceWhileRefreshing: true,
  statusCodes: [401, 403],
});

const paramsSerializer = (params: Record<string, any>) => {
  return Object.entries(params)
    .map(([key, value]) =>
      Array.isArray(value)
        ? value.map((v) => `${key}=${encodeURIComponent(v)}`).join('&')
        : `${key}=${encodeURIComponent(value)}`
    )
    .join('&');
};

export { APIv4, setCityIdForApi, paramsSerializer };
